import React, { useRef, useState } from "react";

interface AudioPlayerProps {
  src: string;
  onClose?: () => void;
}

const AudioPlayer = ({ src, onClose }: AudioPlayerProps) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTimeUpdate = (e: React.ChangeEvent<HTMLAudioElement>) => {
    e.stopPropagation();
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = (e: React.ChangeEvent<HTMLAudioElement>) => {
    e.stopPropagation();
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (audioRef.current) {
      audioRef.current.currentTime = parseFloat(e.target.value);
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleSkip = (e: React.MouseEvent<HTMLButtonElement>, amount: number) => {
    e.stopPropagation();
    if (audioRef.current) {
      audioRef.current.currentTime += amount;
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className=" relative w-full max-w-md p-4 pt-6 mx-auto bg-white rounded-[12px] shadow-lg" onClick={e => e.stopPropagation()}>
      {onClose && (
        <div className="absolute top-0 right-0 flex flex-row gap-3">
          <div className="content-center w-5 h-5 align-middle shadow-md top-1 right-1 rounded-3xl bg-slate-600">
            <button className="absolute top-0 left-0 right-0 w-5 h-5 text-white " onClick={() => onClose()}>
              ×
            </button>
          </div>
        </div>
      )}
      <audio
        ref={audioRef}
        src={src} // Replace with your audio file path
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
      />
      <input type="range" min="0" max={duration} value={currentTime} onChange={handleSeek} className="w-full mb-2 accent-black" />
      <div className="flex justify-between mb-2 text-xs text-gray-600">
        <span>{formatTime(currentTime)}</span>
        <span>{`-${formatTime(duration - currentTime)}`}</span>
      </div>
      <div className="flex items-center justify-between">
        <button onClick={e => handleSkip(e, -5)} className="text-2xl">
          ↺ <span className="text-sm ">{5}</span>
        </button>
        <button onClick={handlePlayPause} className="text-2xl">
          {isPlaying ? "❚❚" : "►"}
        </button>
        <button onClick={e => handleSkip(e, 5)} className="text-2xl">
          ↻ <span className="text-sm ">{5}</span>
        </button>
      </div>
    </div>
  );
};

export default AudioPlayer;
